/** @format */

import { END_POINT, headersFormData } from "utils";
import { deleteRequest, getRequest, postRequest } from "./axios";
import { IdForm, FormMemberStore, FormMemberUpdate } from "types";
import { toFormData } from "axios";

export const memberService = {
  onGetList: async (page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.MEMBERS.LIST}?page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  onSearch: async (q, page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.MEMBERS.LIST}?q=${q}&page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: FormMemberStore) => {
    try {
      const rs = await postRequest(`${END_POINT.MEMBERS.LIST}`, toFormData(payload), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: FormMemberUpdate) => {
    try {
      const rs = await postRequest(`${END_POINT.MEMBERS.LIST}/${payload.id}`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (payload: IdForm) => {
    try {
      const rs = await deleteRequest(`${END_POINT.MEMBERS.LIST}/${payload.id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};

